import { render, staticRenderFns } from "./wang-luo-ling-shou.vue?vue&type=template&id=65db897f&scoped=true"
import script from "./wang-luo-ling-shou.vue?vue&type=script&lang=js"
export * from "./wang-luo-ling-shou.vue?vue&type=script&lang=js"
import style0 from "./wang-luo-ling-shou.vue?vue&type=style&index=0&id=65db897f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_00c06ca9196352b30e67b45b8b60d79f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65db897f",
  null
  
)

export default component.exports